import List from "@/components/list";

const Table = args => {
  const { listeners } = args;
  const RCSelectionChange = listeners["selection-change"] || function () { };

  const tableConfig = [
    {
      type: "selection",
      label: "main",
    },
    {
      label: "文章名",
      prop: "articleName",
      minWidth: "150",
      showOverflowTooltip: true
    },
    {
      label: "展示终端",
      prop: "displayTypeName",
      minWidth: "140"
    },
    {
      label: "期刊名称",
      prop: "periodicalName",
      minWidth: "150",
      showOverflowTooltip: true
    },
    {
      label: "点击量",
      prop: "playNum",
      minWidth: "80"
    },
    // {
    //   label: "收藏人数",
    //   prop: "collectCount",
    //   minWidth: "100",
    //   showOverflowTooltip: true,
    // },
  ];
  if (args.props.userType == -1 && args.props.deptLevelCode == "001") {
    tableConfig.splice(3, 0, {
      label: "所属分院",
      prop: "deptName",
      width: "120",
      showOverflowTooltip: true
    });
  }
  return (
    <List
      {...args}
      talbeCols={tableConfig}
      onSelectionChange={RCSelectionChange}
    />
  );
};

export default Table;
